import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'PlayerData',
        });

        let { player } = result;
        let loggedIn = player ? true : false;

        if (loggedIn) {
            return {
                loggedIn: loggedIn,
                player: {
                    name: player.first_name + ' ' + player.last_name,
                    email: player.email,
                    first_name: player.first_name,
                    last_name: player.last_name,
                    email_confirm: player.email,
                    player_id: player.id,
                    address1: player.address1,
                    address2: player.address2,
                    city: player.city,
                    state: player.state,
                    zip: player.zip,
                    phone1: player.phone1,
                    area_phone1: player.phone1.split('-')[0],
                    prefix_phone1: player.phone1.split('-')[1],
                    suffix_phone1: player.phone1.split('-')[2],
                    phone2: player.phone2,
                    area_phone2: player.phone2.split('-')[0],
                    prefix_phone2: player.phone2.split('-')[1],
                    suffix_phone2: player.phone2.split('-')[2],
                    dob_year: player.dob.split('-')[0],
                    dob_month: player.dob.split('-')[1],
                    dob_day: player.dob.split('-')[2],
                },
            };
        } else if (result.response) {
            return {
                loggedIn: false,
                errors: result.response.message,
            };
        } else {
            return {
                loggedIn: false,
                errors: 'Unspecified Error',
            };
        }
    };
};
